<template>
  <div class="contact-card-wrapper pt-4 pb-5 pr-2">
    <div class="eh-section-title pb-1">{{ cardData.title }}</div>
    <div class="contact-card-description pb-4">{{ cardData.description }}</div>
    <div class="pb-2" v-for="(action, i) in cardData.actions" :key="i">
      <div v-show="!action.isHidden">
        <div class="d-inline-block">
          <!-- url-based action -->
          <external-link
            v-if="action.url"
            :href-url="action.url"
            :target="action.target"
            :event="event"
            :sub-event="createSubEvent(cardData, action)"
            >{{ action.text }}</external-link
          >
          <!-- function-based action -->
          <div
            v-else="action.triggerFn"
            class="eh-link"
            @click="triggerAction(cardData, action)"
          >
            {{ action.text }}
            <font-awesome-icon
              class="ml-1"
              icon="external-link-alt"
              size="sm"
            />
          </div>
        </div>
        <div v-if="action.note" class="contact-card-action-note d-inline-block">
          {{ action.note }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExternalLink from "../ExternalLink";
import * as CONSTANTS from "@/store/constants";

export default {
  name: "contact-card",
  props: ["cardData"],
  components: {
    ExternalLink,
  },
  data() {
    return {
      event: "Contact Support - Link clicked",
    };
  },
  methods: {
    triggerAction(cardData, action) {
      // invoke trigger function as defined in constants
      let triggerFn = action.triggerFn;
      if (triggerFn) triggerFn(this);

      let subEvent = this.createSubEvent(cardData, action);
      this.$hhMixpanel.trackEvent(this.event, { subEvent: subEvent });
    },
    createSubEvent(cardData, action) {
      let subEvent = `${cardData.title}, ${action.text}`;
      if (action.url) subEvent = `${subEvent} - ${action.url}`;
      return subEvent;
    },
  },
};
</script>

<style scoped>
.contact-card-wrapper {
  border-top: 2px solid #cccccc;
  min-height: 240px;
}
.contact-card-description {
  font-size: 16px;
}
.contact-card-action-note {
  font-style: italic;
  font-size: 14px;
}
</style>